export const DEFAULT_PAGINATION = {
  assignees: [],
  hasMore: false,
  offset: 0
};
export const ASSIGN_TO_TEAM_SECTION = 'ASSIGN_TO_TEAM_SECTION';
export const ASSIGN_TO_USER_SECTION = 'ASSIGN_TO_USER_SECTION';
export const SEARCH_MORE_OPTION = 'SEARCH_MORE_OPTION';
export const UNASSIGN_OPTION = 'UNASSIGN_OPTION';